import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Medico } from '../../medico/medico';
import { MedicoPlanoSaude } from '../../medico/medico-plano-saude';
import { MedicoService } from '../../medico/medico.service';
import { MedicoPlanoSaudePk } from '../../medico/pks/medico-plano-saude-pk';
import { PlanoSaudeService } from '../../plano-saude/plano-saude.service';
import { AbastractAssociacao } from '../abstract.associacao';

@Component({
  selector: 'app-associacao-medico-plano-saude',
  templateUrl: '../associacao.component.html',
  styleUrls: ['../associacao.component.css']
})
export class AssociacaoMedicoPlanoSaudeComponent extends AbastractAssociacao {

  constructor(private medicoService: MedicoService,
    private planoSaudeService: PlanoSaudeService,
    formBuilder: FormBuilder,
    dialog: MatDialog) {

    super(formBuilder, dialog);

  }

  ngOnInit() {

    super.ngOnInit();

    this.tituloAssociacao = 'Associação Médico x Plano Saúde';
    this.nomeCampoAssociacaoPai = 'Médico';
    this.nomeCampoAssociacaoFilho = 'Plano Saúde';

    this.configurarForm();
  }

  getListaDePais(): Observable<any> {

    return this.medicoService.listarMedicosComRelacaoMinimaDePlanoSaude();

  }

  getListaDeFilhos(): Observable<any> {

    return this.planoSaudeService.listarPlanoSaudeFiltroInativoOuInternoComProjecao(false, true);

  }

  getListaDeFilhosSelecionados(): any {

    return (this.associacaoPai as Medico).medicoPlanoSaude;

  }

  getIdFilhoFromAssociacaoComPai(currentAssociacao: any): any {

    return currentAssociacao.pk.idPlanoSaude;
  }

  configurarAssociacoesFilhas(associacoesFilhas: any): void {

    let pai: Medico = this.associacaoPai as Medico;

    pai.medicoPlanoSaude = [];

    if (associacoesFilhas) {

      associacoesFilhas.forEach((currentFilho: any) => {
        pai.medicoPlanoSaude.push(this.getAssociacaoPaiFilho(currentFilho));
      });

    }
  }

  getAssociacaoPaiFilho(currentFilho: any): any {

    const associacao: MedicoPlanoSaude = new MedicoPlanoSaude();
    associacao.pk = new MedicoPlanoSaudePk();
    associacao.pk.idMedico = this.associacaoPai.id;
    associacao.pk.idPlanoSaude = currentFilho.id;

    return associacao;

  }

  salvarAssociacao(value: any): Observable<Object> {

    return this.medicoService.atualizaRelacaoMedicoPlanoSaude(value);
  }

}
